import Vue from 'vue'
import Grid from './grid.vue'
import Form from './form.vue'

Vue.component('simple-crud-grid', Grid)
Vue.component('simple-crud-form', Form)
